import { Component } from '@angular/core';
import {
  AbstractControl,
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  ValidationErrors,
  Validators
} from "@angular/forms";
import { UserService } from "../../services/user.service";
import { ToastrService } from "ngx-toastr";
import { MatError, MatFormField, MatLabel, MatFormFieldModule } from "@angular/material/form-field";
import { MatInput } from "@angular/material/input";
import { MatButton } from "@angular/material/button";
import { MatIcon } from "@angular/material/icon";

@Component({
  selector: 'app-change-password',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatError,
    MatFormField,
    MatFormFieldModule,
    MatInput,
    MatLabel,
    MatButton,
    MatIcon
  ],
  templateUrl: './change-password.component.html',
  styleUrl: './change-password.component.css'
})

export class ChangePasswordComponent {
  changePasswordForm: FormGroup;

  constructor(private userService: UserService, private toastService: ToastrService, private fb: FormBuilder

  ) {
    this.changePasswordForm = this.fb.group({
      oldPassword: ['', [Validators.required, Validators.minLength(3)]],
      newPassword: ['', [Validators.required, Validators.minLength(8), Validators.pattern(/^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[^a-zA-Z0-9]).*$/)]],
      confirmNewPassword: ['', [Validators.required, Validators.minLength(8)]]
    }, {
      validators: [
        (group: AbstractControl): ValidationErrors | null => {
          const newPassword = group.get('newPassword')?.value;
          const confirmNewPassword = group.get('confirmNewPassword')?.value;
          return newPassword === confirmNewPassword ? null : { passwordsMismatch: true };
        }
      ]
    });
  }

  get confirmNewPassword() {
    return this.changePasswordForm.get('confirmNewPassword');
  }

  onSubmit() {
    if (this.changePasswordForm.invalid) {
      this.toastService.error('Preencha todos os campos corretamente!');
      return;
    }

    const { oldPassword, newPassword, confirmNewPassword } = this.changePasswordForm.value;

    if (newPassword !== confirmNewPassword) {
      this.toastService.error('As senhas novas nÃ£o coincidem!');
      return;
    }

    this.userService.changePassword(oldPassword, newPassword, confirmNewPassword).subscribe(
      () => {
        this.toastService.success('Senha alterada com sucesso!');
      },
      (errorMessage) => {
        this.toastService.error(errorMessage);

      }
    );
    this.changePasswordForm.reset();
  }
}
